<template>
  <div :data-test="`edit-member-${member.uuid}`">
    <div class="p-4 bg-gray-100 rounded flex items-center space-x-2">
      <svg v-if="!$v.$invalid" class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-700" viewBox="0 0 20 20" fill="currentColor">
        <!-- eslint-disable-next-line -->
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
      </svg>
      <div class="flex items-baseline space-x-2">
        <p class="font-medium">{{ member.displayName }}</p>
        <p
          v-if="$v.$invalid"
          class="text-sm text-gray-600"
        >More info required</p>
      </div>
      <div class="flex-1 flex justify-end">
        <button @click="showInfo = true" class="focus:outline-none" data-test="show-info">
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"></path><path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd"></path></svg>
        </button>
      </div>
    </div>
    <m-modal
      isSidebar
      sidebarHeaderText="Member Information"
      :show="showInfo"
      @close="showInfo = false"
    >
      <member-info :member="member" @close="showInfo = false" />
    </m-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import MemberInfo from './member-info/member-info.vue';

export default {
  name: 'member',
  components: {
    MemberInfo,
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  validations: {
    member: {
      additionalInfo: {
        currentWorkStatus: {
          value: {
            required,
          },
        },
        contributionPlans: {
          value: {
            required,
          },
        },
        incomeNeeds: {
          value: {
            required,
          },
        },
        longTermIncomeNeeds: {
          value: {
            required,
          },
        },
        riskAppetite: {
          value: {
            required,
          },
        },
      },
    },
  },
};
</script>
